import { useState } from 'react';
import { Select, MenuItem, InputLabel, Autocomplete, TextField } from "@material-ui/core";

const SelectComponent = (props: any) => {
  const items = props?.others?.data.map((i: any) => ({ label: `${i?.firstName} ${i?.lastName}`, id: i?.id }));
  const [value, setValue] = useState();
  const [inputValue, setInputValue] = useState();
  const {
    patient,
    checklistItem,
    refreshChecklistHandler,
    refreshRecordHandler,
  } = props?.others;

  return (
    <>
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        value={value}
        inputValue={inputValue}
        onInputChange={(event: any, newInputValue: any) => {
          setInputValue(newInputValue);
        }}
        options={items}
        renderInput={(params) => <TextField {...params} label={props?.name || props?.elementName} />}
        onChange={(event: any, username: any | null) => {
          setValue(username);
          props?.others?.handler({
            record: patient,
            checklistItem,
            refreshChecklistHandler,
            refreshRecordHandler,
            more: { selectedUser: username?.id},
          })
        }}
      />
    </>
  );
};

export default SelectComponent;
